export enum ExploreActionTypes {
  API_RESPONSE_SUCCESS  = '@@explore/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR    = '@@explore/API_RESPONSE_ERROR',
  SEND_MESSAGE          = '@@explore/SEND_MESSAGE',
  SUMMARISE             = '@@explore/SUMMARISE',
  RESET                 = '@@explore/RESET',
}

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
  timestamp: string;
}

export interface ProposedInsight {
  distilledInsight: string;
  topic: string;
  toneTags: string[];
  hook: string;
}

export interface TopInsight {
  distilledInsight: string;
  topic: string;
  toneTags: string[];
  hook: string;
  score: number;
}

export interface ExploreState {
  sessionId: string | null;
  messages: ChatMessage[];
  topInsights: TopInsight[];
  isReadyToSummarise: boolean;
  proposedInsight: ProposedInsight | null;
  isLoading: boolean;
  isSummarising: boolean;
  error: string | null;
}
